<bds-hot-list-details [hotLists]="hotLists$ | async" (saved)="setHotLists()">
    <button mat-stroked-button (click)="add()">
        <fa-icon [icon]="iconAdd"></fa-icon>
        Add
    </button>
</bds-hot-list-details>
